export const CHROME_WEB_STORE_URL = 'https://chromewebstore.google.com/detail/kchedjnhaejeipbbhfedfinoccffplbp';
export const EXTENSION_GUIDE_URL = 'https://claude.ai/artifact/FnMoZjMufSTvg9TEm8JqNC?sk=4tdKmUdIYX0UN_gfh8ZV8g';
